
import React from 'react'
function fanAutoEnabled() {
 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M11.75 22.75C17.8251 22.75 22.75 17.8251 22.75 11.75C22.75 5.67487 17.8251 0.75 11.75 0.75C5.67487 0.75 0.75 5.67487 0.75 11.75C0.75 17.8251 5.67487 22.75 11.75 22.75Z" stroke="#6B7073" stroke-width="1.5"/>
  <path d="M7.75 16.25L9.34412 11.8662M9.34412 11.8662L11.2671 6.57792C11.4261 6.14069 12.0445 6.14069 12.2035 6.57792L14.1265 11.8662M9.34412 11.8662H14.1265M14.1265 11.8662L15.7206 16.25" stroke="#6B7073" stroke-width="1.5" stroke-linecap="round"/>
</svg>
 )}
export default fanAutoEnabled